import React, { Component } from "react";
import { StyledHeader } from "./style.js";
import { Header } from "semantic-ui-react";

export default class SimpleReportHeader extends Component {
  render() {
    const datasetUnitName =
      this.props.summaryReport && this.props.summaryReport.datasetUnitNamePlural
        ? this.props.summaryReport.datasetUnitNamePlural
        : "work settings";
    return (
      <StyledHeader>
        <Header as="h1" className={this.props.smallerHeader ? "smaller-header" : ''}>
          {this.props.title}
        </Header>
      </StyledHeader>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SRHHeaders/SimpleReportHeader/index.jsx